import Vue from 'vue'
import App from './App'
import router from './router'
import VueResource from 'vue-resource'
import VueSwal from 'vue-swal'
import store from './store'
import helpers from './helpers'
import pkg from '../package.json'

import 'bootstrap/dist/css/bootstrap.min.css'
import '../../assets/css/main.css'

Vue.use(VueSwal);
Vue.use(VueResource);
Vue.use(helpers);

Vue.config.productionTip = false;

const base_server = getAmbiente() + '/delivery/';
const base_cdn = 'https://lecard-cdn.nyc3.cdn.digitaloceanspaces.com';
const base_assets = `${base_cdn}/lecard-go`;

function getAmbiente() {
  const base_server = process.env.VUE_APP_BASE_SERVER || null;

  if (base_server) {
    return base_server;
  }

  const ambiente = process.env.VUE_APP_AMBIENTE || null;

  switch (ambiente) {
    case '4':
      return 'http://localhost/lecard-server';

    case '3':
      return 'https://dev.lecard.app.br';

    case '2':
      return 'https://beta.lecard.app.br';

    default:
      return 'https://delivery.lecard.app.br';
  }
}

Vue.mixin({
  data() {
    return {
      envEmpresa: {},
      base_cdn: `${base_cdn}/lecard-corporativo`,
      app_version: pkg.version,
      base_assets,
      origin: '5',
      img_default: (base_cdn + '/lecard-corporativo/static/imgs/default.png'),
      is_plus: false
    }
  }
});

Vue.http.options.emulateJSON = true;
Vue.http.options.emulateHTTP = true;
Vue.http.options.root = base_server;

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app');
